import { FC, useCallback } from 'react';
import { Box } from '@mui/material';
import { Exclusion, ExclusionSortKey } from '../../types/exclusion-types';
import config from '../../config/exclusions-config.json';
import { useExclusionsTableHeader } from '../../hooks/use-exclusions-table-header';
import { setSelectedExclusion } from '../../store-actions/exclusions-store-actions';
import OxDataGrid from '../../../elements/OxDataGrid/OxDataGrid';

const ExclusionsTable: FC<React.PropsWithChildren<ExclusionsTableProps>> = ({
  exclusions,
  onSort,
}) => {
  const columns = useExclusionsTableHeader();
  const handleClick = useCallback((clickedExclusion: Exclusion) => {
    setSelectedExclusion(clickedExclusion);
  }, []);

  return (
    <Box
      width='100%'
      height='100%'
      border='none'
      display='flex'
      sx={{ borderRadius: '10px', border: 0, overflow: 'hidden' }}>
      <OxDataGrid
        rowHeight={config.table.rowHeight}
        columns={columns}
        rows={exclusions}
        onRowClick={handleClick}
        onSort={onSort as (key?: string) => void}
        defaultColumnOptions={{
          sortable: true,
          resizable: false,
        }}
      />
    </Box>
  );
};

export interface ExclusionsTableProps {
  exclusions: Exclusion[];
  onSort?: (key: ExclusionSortKey) => void;
}

export default ExclusionsTable;
